import React from 'react'

const OutlinedButton = ({ label, onClick }) => (
  <button onClick={onClick} className='button-default button-outlined'>
    {label}
  </button>
)

export { OutlinedButton }
